import gql from 'graphql-tag';

export const unitFragments = gql`
  fragment unitFragments on Unit {
    id
    name
    unofficialName
    isCompany
    canReceiveEhf3
    highestPriorityIdentity {
      id
      value
      identificator {
        id
        name
      }
    }
  }
`;

export const unitContactFragments = gql`
  fragment unitContactFragments on Unit {
    mobile
    phone
    email
  }
`;

export const unitAddressFragments = gql`
  fragment unitAddressFragments on Unit {
    id
    city
    address
    zip
    country {
      code
      name
    }
  }
`;
